
import { GET_REPORTED_POSTS, GET_SEARCHES,GET_FAVOURITES,REPORTED_BY,VIEWED_BY,POST_DETAILS,DELETE_POST } from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import {changeParamsToQuery} from './commonFn';
export class PostService {

  static instance;


  static getInstance() {
    if (!PostService.instance) {
      PostService.instance = new PostService();
    }
    return PostService.instance;
  }
  fetchReportPost = async (params) => {
    let newsResponse = await Api.get(`${GET_REPORTED_POSTS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  fetchSearches = async (params) => {
    
    let newsResponse = await Api.get(`${GET_SEARCHES.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  fetchFavourites = async (params) => {
    let newsResponse = await Api.get(`${GET_FAVOURITES.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  fetchReportedBy = async (params) => {
    let newsResponse = await Api.get(`${REPORTED_BY.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  fetchViewedBy = async (params) => {
    let newsResponse = await Api.get(`${VIEWED_BY.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  fetchPostDetails = async (params) => {
    let newsResponse = await Api.get(`${POST_DETAILS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  deletePost = async (params) => {
    let newsResponse = await Api.delete(`${DELETE_POST.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }




}

